<style scoped="scoped" lang="scss">
.hideFormItem {
  display: none !important;
}

.container {
  padding-left: 24px;
  padding-right: 24px;
  //overflow: auto;
  //min-width: 500px;

  // 隐藏表单项
  .hideFormItem {
    display: none !important;
  }
}
</style>
<template>
  <div class="container">
    <div>
      <el-tabs v-model="activeName" @tab-click="changeTab">
        <!-- 指标汇总 -->
        <el-tab-pane :label="$t('zhibiaohuizong')" name="first">
          <indicator_summary ref="indicator_summary" @navTo="navTo"></indicator_summary>
        </el-tab-pane>
        <!-- 设备KPI -->
        <el-tab-pane :label="$t('shebeiKPI')" name="second">
          <device_kpi ref="device_kpi" :parentParams="parentParams"></device_kpi>
        </el-tab-pane>
        <!-- 生产统计 -->
        <el-tab-pane :label="$t('shengchantongji')" name="third">
          <production_statistics ref="production_statistics" :parentParams="parentParams"></production_statistics>
        </el-tab-pane>
        <!-- 质量统计 -->
        <el-tab-pane :label="$t('zhiliangtongji')" name="fourth">
          <quality_statistics ref="quality_statistics" :parentParams="parentParams"></quality_statistics>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script type="text/javascript">
import indicator_summary from '@@/pages/web/report/equipment_capacity_statistics/indicator_summary'
import device_kpi from '@@/pages/web/report/equipment_capacity_statistics/device_kpi'
import production_statistics from '@@/pages/web/report/equipment_capacity_statistics/production_statistics/index'
import quality_statistics from '@@/pages/web/report/equipment_capacity_statistics/quality_statistics/index'

export default {
  name: 'web_report_equipment_capacity_statistics_list',
  components: {
    indicator_summary,
    device_kpi,
    production_statistics,
    quality_statistics
  },
  data() {
    return {
      key: '',
      activeName: 'first',
      parentParams: {}
    }
  },
  created() {
    setTimeout(() => {
      this.utils.event_hub.$on('QUALITY_STATISTICS_REFRESH', () => {

      })
    }, 300)
  },
  mounted() {
    this.resize()
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
  },
  methods: {
    /*tab的变化*/
    changeTab(tab) {
      if(tab.name=="third"){
        this.utils.event_hub.$emit('PRODUCTION_STATISTICS_RESIZE')
      }
      if(tab.name=="fourth"){

        this.utils.event_hub.$emit('QUALITY_STATISTICS_RESIZE')
      }

    },
    /**
     * 本年
     * @returns {{firstDate: string, lastDate: string}}
     */
    getCurrentYear() {
      const dates = new Date()
      const year = dates.getFullYear()
      const month = (dates.getMonth() + 1) > 9 ? (dates.getMonth() + 1) : '0' + (dates.getMonth() + 1)
      const date = dates.getDate()
      const firstDate = year + '-' + '01' + '-' + '01' + ' 00:00:00'
      // const lastDate = year + '-' + month + '-' + (date - 1) + ' 23:59:59'
      const lastDate = year + '-' + month + '-' + (date - 1) + ' 23:59:59'
      return {
        firstDate,
        lastDate
      }
    },
    /**
     * 本月
     * @returns {{firstDate: string, lastDate: string}}
     */
    getCurrentMonth() {
      const dates = new Date()
      const year = dates.getFullYear()
      const month = (dates.getMonth() + 1) > 9 ? (dates.getMonth() + 1) : '0' + (dates.getMonth() + 1)
      const date = dates.getDate()
      const firstDate = year + '-' + month + '-' + '01' + ' 00:00:00'
      const lastDate = year + '-' + month + '-' + (date) + ' 23:59:59'
      return {
        firstDate,
        lastDate
      }
    },
    /**
     * 上月
     * @returns {{firstDate: string, lastDate: string}}
     */
    getBeforeMonth() {
      var nowdays = new Date();
      var year = nowdays.getFullYear();
      var month = nowdays.getMonth();
      if(month==0){
        month = 12;
        year = year-1;

      }
      if(month<10){
        month = '0'+month;
      }
      var myDate = new Date(year,month,0);
      var firstDate = year+'-'+month+'-01 00:00:00'; //上个月第一天
      var lastDate = year+'-'+month+'-'+myDate.getDate()+' 23:59:00';//上个月最后一天
      return {
        firstDate,
        lastDate
      }
    },
    /**
     * 昨天
     * @returns {{firstDate: string, lastDate: string}}
     */
    getBeforeDate() {
      const dates = new Date()
      const year = dates.getFullYear()
      const month = (dates.getMonth() + 1) > 9 ? (dates.getMonth() + 1) : '0' + (dates.getMonth() + 1)
      const date = dates.getDate() - 1
      const firstDate = year + '-' + month + '-' + date + ' 00:00:00'
      const lastDate = year + '-' + month + '-' + date + ' 23:59:59'
      return {
        firstDate,
        lastDate
      }
    },
    /**
     * 传递日期
     * @param desc
     * @returns {null}
     */
    getTime(desc) {
      let result = null
      switch (desc) {
        case '今年':
          result = this.getCurrentYear()
          break
        case '本月':
          result = this.getCurrentMonth()
          break
        case '上月':
          result = this.getBeforeMonth()
          break
        case '昨天':
          result = this.getBeforeDate()
          break
      }
      if (result !== null) {
        for (let i in result) {
          console.log('dddddd',i)
          this.$set(this.parentParams, i, result[i])
        }
      }
    },
    /**
     * 跳转
     * equipKpi、proSum、qualitySum
     * @param value
     */

    navTo(value) {
      const {type, row} = value
      console.log('dddddnavTo', row)
      const {summaryDateDesc} = row
      // if(this.activeName = 'second') {
      //   this.$set(this.parentParams, 'second', this.activeName)
      // }
      switch (type) {
        case 'equipKpi':
          this.activeName = 'second'
          this.$set(this.parentParams, 'second', this.activeName)
            console.log('22222this.parentParams',this.parentParams)
          // this.$nextTick(()=>{
          //   this.$refs.equipKpi.orgIdSelected= row.orgId
          //   console.log('this.$refs',this.$refs.equipKpi.orgId)
          //   this.$refs.equipKpi.getSummary()
          //   console.log('this.$refs',this.$refs.equipKpi.getSummary())
          // })
          break
        case 'proSum':
          this.activeName = 'third'
          this.$set(this.parentParams, 'third', this.activeName)
          break
        case 'qualitySum':
          this.activeName = 'fourth'
          break
      }
      this.$set(this.parentParams, 'orgId', row.orgId)
      this.$set(this.parentParams, 'selectedOrgIds', row.selectedOrgId)
      this.getTime(summaryDateDesc)
    }
  }
}
</script>
